// Existing action types
export const ADD_PAYMENT_REQUEST_REQUEST = "ADD_PAYMENT_REQUEST_REQUEST";
export const ADD_PAYMENT_REQUEST_SUCCESS = "ADD_PAYMENT_REQUEST_SUCCESS";
export const ADD_PAYMENT_REQUEST_FAILURE = "ADD_PAYMENT_REQUEST_FAILURE";
export const ADD_APPROVE_REQUEST_REQUEST = "ADD_APPROVE_REQUEST_REQUEST";
export const ADD_APPROVE_REQUEST_SUCCESS = "ADD_APPROVE_REQUEST_SUCCESS";
export const ADD_APPROVE_REQUEST_FAILURE = "ADD_APPROVE_REQUEST_FAILURE";
export const ADD_ATTEST_REQUEST_REQUEST = "ADD_ATTEST_REQUEST_REQUEST";
export const ADD_ATTEST_REQUEST_SUCCESS = "ADD_ATTEST_REQUEST_SUCCESS";
export const ADD_ATTEST_REQUEST_FAILURE = "ADD_ATTEST_REQUEST_FAILURE";
export const ADD_VERIFY_REQUEST_REQUEST = "ADD_VERIFY_REQUEST_REQUEST";
export const ADD_VERIFY_REQUEST_SUCCESS = "ADD_VERIFY_REQUEST_SUCCESS";
export const ADD_VERIFY_REQUEST_FAILURE = "ADD_VERIFY_REQUEST_FAILURE";
export const ADD_REJECT_REQUEST_REQUEST = "ADD_REJECT_REQUEST_REQUEST";
export const ADD_REJECT_REQUEST_SUCCESS = "ADD_REJECT_REQUEST_SUCCESS";
export const ADD_REJECT_REQUEST_FAILURE = "ADD_REJECT_REQUEST_FAILURE";
export const ADD_PAY_REQUEST_REQUEST = "ADD_PAY_REQUEST_REQUEST";
export const ADD_PAY_REQUEST_SUCCESS = "ADD_PAY_REQUEST_SUCCESS";
export const ADD_PAY_REQUEST_FAILURE = "ADD_PAY_REQUEST_FAILURE";
export const ADD_QUERY_REQUEST_REQUEST = "ADD_QUERY_REQUEST_REQUEST";
export const ADD_QUERY_REQUEST_SUCCESS = "ADD_QUERY_REQUEST_SUCCESS";
export const ADD_QUERY_REQUEST_FAILURE = "ADD_QUERY_REQUEST_FAILURE";
export const ADD_COMMENT_REQUEST_REQUEST = "ADD_COMMENT_REQUEST_REQUEST";
export const ADD_COMMENT_REQUEST_SUCCESS = "ADD_COMMENT_REQUEST_SUCCESS";
export const ADD_COMMENT_REQUEST_FAILURE = "ADD_COMMENT_REQUEST_FAILURE";
export const FETCH_PAYMENT_REQUESTS_REQUEST = "FETCH_PAYMENT_REQUESTS_REQUEST";
export const FETCH_PAYMENT_REQUESTS_SUCCESS = "FETCH_PAYMENT_REQUESTS_SUCCESS";
export const FETCH_PAYMENT_REQUESTS_FAILURE = "FETCH_PAYMENT_REQUESTS_FAILURE";
export const UPDATE_PAYMENT_REQUEST_REQUEST = "UPDATE_PAYMENT_REQUEST_REQUEST";
export const UPDATE_PAYMENT_REQUEST_SUCCESS = "UPDATE_PAYMENT_REQUEST_SUCCESS";
export const UPDATE_PAYMENT_REQUEST_FAILURE = "UPDATE_PAYMENT_REQUEST_FAILURE";
export const DELETE_PAYMENT_REQUEST_REQUEST = "DELETE_PAYMENT_REQUEST_REQUEST";
export const DELETE_PAYMENT_REQUEST_SUCCESS = "DELETE_PAYMENT_REQUEST_SUCCESS";
export const DELETE_PAYMENT_REQUEST_FAILURE = "DELETE_PAYMENT_REQUEST_FAILURE";
export const CLEAR_PAYMENT_REQUESTS_ERROR = "CLEAR_PAYMENT_REQUESTS_ERROR";
export const FETCH_PAYMENT_REQUEST_DETAILS_REQUEST =
  "FETCH_PAYMENT_REQUEST_DETAILS_REQUEST";
export const FETCH_PAYMENT_REQUEST_DETAILS_SUCCESS =
  "FETCH_PAYMENT_REQUEST_DETAILS_SUCCESS";
export const FETCH_PAYMENT_REQUEST_DETAILS_FAILURE =
  "FETCH_PAYMENT_REQUEST_DETAILS_FAILURE";
export const FETCH_PAYMENT_REQUEST_VOUCHERS_REQUEST =
  "FETCH_PAYMENT_REQUEST_VOUCHERS_REQUEST";
export const FETCH_PAYMENT_REQUEST_VOUCHERS_SUCCESS =
  "FETCH_PAYMENT_REQUEST_VOUCHERS_SUCCESS";
export const FETCH_PAYMENT_REQUEST_VOUCHERS_FAILURE =
  "FETCH_PAYMENT_REQUEST_VOUCHERS_FAILURE";
export const SUBMIT_PAYMENT_REQUEST_REQUEST = "SUBMIT_PAYMENT_REQUEST_REQUEST";
export const SUBMIT_PAYMENT_REQUEST_SUCCESS = "SUBMIT_PAYMENT_REQUEST_SUCCESS";
export const SUBMIT_PAYMENT_REQUEST_FAILURE = "SUBMIT_PAYMENT_REQUEST_FAILURE";
export const UPLOAD_RECEIPT_REQUEST = "UPLOAD_RECEIPT_REQUEST";
export const UPLOAD_RECEIPT_SUCCESS = "UPLOAD_RECEIPT_SUCCESS";
export const UPLOAD_RECEIPT_FAILURE = "UPLOAD_RECEIPT_FAILURE";

// New action types for fetching receipt
export const FETCH_RECEIPT_REQUEST = "FETCH_RECEIPT_REQUEST";
export const FETCH_RECEIPT_SUCCESS = "FETCH_RECEIPT_SUCCESS";
export const FETCH_RECEIPT_FAILURE = "FETCH_RECEIPT_FAILURE";

export const FETCH_SUPPORTING_DOCUMENT_REQUEST =
  "FETCH_SUPPORTING_DOCUMENT_REQUEST";
export const FETCH_SUPPORTING_DOCUMENT_SUCCESS =
  "FETCH_SUPPORTING_DOCUMENT_SUCCESS";
export const FETCH_SUPPORTING_DOCUMENT_FAILURE =
  "FETCH_SUPPORTING_DOCUMENT_FAILURE";
